import styled from 'styled-components';

import { Checkbox } from '@/core/components/Checkbox';

export const CheckboxWrapper = styled.label`
  position: relative;
  display: flex;
  width: 100%;
  margin: 10px;
  cursor: pointer;

  svg {
    margin-right: 11px;
    border-radius: 3px;
  }

  input {
    opacity: 0;
    width: 0;
  }

  &:focus-within svg {
    box-shadow: 0 0 0 2px currentcolor;
  }
`;

interface FormRadioInputProps {
  checked: boolean;
  color: string;
  onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  name: string;
  label: string;
  ariaLabel?: string;
}

export const FormRadioInput = ({
  checked,
  color,
  onChange,
  name,
  label,
  ariaLabel,
}: FormRadioInputProps) => (
  <CheckboxWrapper>
    <Checkbox
      checked={checked}
      color={color}
    />
    <span aria-hidden="true">{label}</span>
    <input
      aria-label={ariaLabel || label}
      type="checkbox"
      name={name}
      value="phone"
      onChange={onChange}
      checked={checked}
    />
  </CheckboxWrapper>
);
